<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />     
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 496.188 496.188" style="enable-background:new 0 0 496.188 496.188;" xml:space="preserve"> <g> <path d="M196.698,108.246c-5.006-16.197-19.999-27.241-36.96-27.241h-41.996c-17.006,0-32.037,11.116-37.01,27.396L1.629,367.257 c-3.45,11.247-1.355,23.452,5.657,32.902c6.992,9.447,18.05,15.025,29.811,15.025c16.67,0,31.287-11.116,35.747-27.167 l16.263-58.612h95.689l17.514,58.246c4.91,16.345,19.953,27.533,37.051,27.533c12.307,0,23.871-5.846,31.156-15.742 c7.301-9.904,9.448-22.679,5.809-34.42L196.698,108.246z M100.018,272.891l19.808-70.913c5.446-19.337,10.426-44.609,15.398-64.451 h0.946c4.974,19.842,10.959,44.625,16.881,64.451l20.832,70.913H100.018z"/> <path d="M495.093,362.394v-69.026c0-46.676-21.128-85.658-87.331-85.658c-24.577,0-45.017,4.506-59.917,9.814 c-9.902,3.531-15.35,14.109-12.473,24.217l0.197,0.665c1.511,5.319,5.156,9.783,10.065,12.352c4.895,2.571,10.62,3.025,15.87,1.253 c10.85-3.661,23.292-6.082,35.309-6.082c30.462,0,36.154,15.028,36.154,25.582v2.853c-70.256-0.415-116.538,24.346-116.538,75.915 c0,31.68,23.953,60.897,64.171,60.897c23.534,0,43.813-8.538,56.824-24.37h1.198l1.596,8.685 c1.207,6.496,6.864,11.221,13.482,11.221h28.767c3.824,0,7.467-1.587,10.054-4.384c2.602-2.797,3.919-6.554,3.626-10.358 C495.4,386.195,495.093,374.461,495.093,362.394z M434.967,338.44c0,3.649-0.389,7.311-1.218,10.554 c-4.053,12.588-16.639,22.736-32.072,22.736c-13.792,0-24.36-7.71-24.36-23.541c0-23.955,25.188-31.664,57.65-31.267V338.44z"/> </g> </svg>
            Slogan
          </h1>
          <ul class="tabs">
            <li>
              <router-link to="/slogan">Dados</router-link>
            </li>
            <li class="tab-active">
              <router-link to="/slogan/banners">Banners</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-1">
                  <h3 class="subtitle">Imagem tamanho de <strong class="label success">1300 x 566</strong></h3>
                  <label class="button button-success button-lg">
                    <svg style="float: left; margin-right: 12px; width: 18px; height: 18px; fill: #fff;" x="0px" y="0px" viewBox="0 0 315.58 315.58"> <g> <path d="M310.58,33.331H5c-2.761,0-5,2.238-5,5v238.918c0,2.762,2.239,5,5,5h305.58c2.763,0,5-2.238,5-5V38.331 C315.58,35.569,313.343,33.331,310.58,33.331z M285.58,242.386l-68.766-71.214c-0.76-0.785-2.003-0.836-2.823-0.114l-47.695,41.979 l-60.962-75.061c-0.396-0.49-0.975-0.77-1.63-0.756c-0.631,0.013-1.22,0.316-1.597,0.822L30,234.797V63.331h255.58V242.386z"/> <path d="M210.059,135.555c13.538,0,24.529-10.982,24.529-24.531c0-13.545-10.991-24.533-24.529-24.533 c-13.549,0-24.528,10.988-24.528,24.533C185.531,124.572,196.511,135.555,210.059,135.555z"/> </g> </svg>
                    Selecione a Imagem
                    <input type="file" name="img" style="display: none;" accept="image/jpg, image/jpeg, image/png, image/webp" @change="handleUpload()">
                  </label>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col col-1-3" v-for="(img, index) in item.imagens">
                  <div class="thumbnail thumbnail-fixed" v-bind:class="{ 'BorderActive': img === item.currentimg }">
                    <div class="LogoimgBox">
                      <img :src="getImage(img)" />
                    </div>
                    <div class="caption">
                      <div class="caption__actions">
                        <span class="button button-sm success button-disabled" v-if="img === item.currentimg">Ativo</span>
                        <span class="button button-sm" v-else v-on:click="setCurrent(img)">Inativo</span>
                        <br>
                        <br>
                        <button class="button button-sm button-error" v-show="img !== item.currentimg" v-on:click="removeImage(index)">Remover</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
      </SideBar>
    </div>
  </div>
</template>

<script>
import { get, put, del, uploadImage } from '@/helpers/apiRequest'
import { getImage } from '@/helpers/utils'

const url = '/slogan'

export default {
  name: 'banners',
  data () {
    return {
      loading: false,
      item: {
        _id: '',
        currentimg: -1,
        imagens: []
      }
    }
  },
  methods: {
    getImage: getImage,
    onSubmit () {

    },
    handleUpload () {
      event.preventDefault()
      const settings = {
        el: event.target,
        str: `/slogan/imagens/${this.item._id}`,
        dim: '1300x566'
      }
      this.loading = true
      uploadImage(settings)
        .then(json => {
          this.item.imagens.push(json.filename)
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    setCurrent (name) {
      this.loading = true
      const key = 'currentimg'
      put(`/currentimg/slogan/${key}/${this.item._id}/${name}`)
        .then(json => {
          this.item[key] = name
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    removeImage (index) {
      if (this.item.imagens.length === 1) {
        this.$swal({ title: 'Não remova a única imagem', type: 'error' })
        return
      }
      this.$swal({ title: 'Deseja deletar esse catálogo ?', showCancelButton: true, type: 'error' })
        .then(() => {
          this.loading = true
          del(`/upload/slogan/imagens/${this.item._id}/${index}`)
            .then(json => {
              this.item.imagens = this.item.imagens.filter((_, k) => +k !== index)
              this.loading = false
            })
            .catch(err => {
              console.log(err)
            })
        }, () => {})
    }
  },
  beforeMount () {
    this.loading = true
    get(url)
      .then(json => {
        this.loading = false
        this.item = json
      })
      .catch(err => console.log('err', err))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Slogan/Banners.vue